import { ACCORDION_TRANSITION_TIMING } from "@faire/retailer-visitor-shared/views/product/ProductDescriptionAccordions/__internal__/utils";
import { getSpacing } from "@faire/web--source/slate/spacing";
import styled, { css } from "styled-components";
export var AccordionText = styled.div.withConfig({
    componentId: "sc-39fe56a2-0"
})([
    "text-align:start;word-break:break-word;white-space:pre-wrap;width:100%;",
    " ",
    " ",
    " text-overflow:ellipsis;overflow:hidden;transition-property:max-height;",
    ""
], function(param) {
    var $isListOfItems = param.$isListOfItems;
    return $isListOfItems ? css([
        "padding-left:",
        ";"
    ], getSpacing("1x")) : "";
}, function(param) {
    var $isAccordionOpen = param.$isAccordionOpen, $textExpandedHeight = param.$textExpandedHeight, $textCollapsedHeight = param.$textCollapsedHeight;
    return $isAccordionOpen ? css([
        "max-height:",
        "px;"
    ], $textExpandedHeight) : css([
        "max-height:",
        "px;"
    ], $textCollapsedHeight);
}, function(param) {
    var $isFullTextVisible = param.$isFullTextVisible, $maxNumberOfLinesShownWhenCollapsed = param.$maxNumberOfLinesShownWhenCollapsed;
    return !$isFullTextVisible ? css([
        "display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:",
        ";"
    ], $maxNumberOfLinesShownWhenCollapsed) : "";
}, ACCORDION_TRANSITION_TIMING);
